import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { logoWall } from '../data/landing';
import { LogoMark } from './LogoMark';
export function LogoWall() {
  const reduce = useReducedMotion();
  // Each half repeats the logos enough to be wider than any screen; two halves loop seamlessly
  const half = [...logoWall, ...logoWall, ...logoWall];
  const track = [...half, ...half];
  return <section aria-labelledby="logo-wall-heading" data-no-reveal className="overflow-hidden bg-bg pt-16 md:pt-20" data-id="element-234" data-mp="k1gbefihymhn">
      <div className="flex items-baseline justify-between gap-6 px-page" data-id="element-235" data-mp="ozq50lokpf15">
        <h2 id="logo-wall-heading" className="text-[12px] font-medium uppercase tracking-[0.04em] text-fg/60" data-id="element-236" data-mp="b1jj83wwf5hu">
          Part of the KAYS & KAYS ecosystem
        </h2>
        <p className="text-[12px] font-medium uppercase tracking-[0.04em] text-fg/40" data-id="element-237" data-mp="2vqpphqtudf96">
          ({String(logoWall.length).padStart(2, '0')})
        </p>
      </div>

      {/* Auto-scrolling strip of square logo tiles */}
      <div className="mt-4" data-id="element-238" data-mp="27fraz4u02li8">
        <motion.ul className="flex w-max gap-2" animate={reduce ? undefined : {
        x: ['-50%', '0%']
      }} transition={{
        duration: 120,
        ease: 'linear',
        repeat: Infinity
      }} data-id="element-239" data-mp="27eydyvkufada">
          {track.map((logo, i) => <li key={`${logo.name}-${i}`} aria-hidden={i >= logoWall.length ? true : undefined} className="group flex h-[72px] w-[38vw] shrink-0 cursor-default items-center justify-center rounded-card border border-line bg-bg transition-colors duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] hover:border-fg/25 sm:w-[32vw] md:h-[120px] md:w-[232px]" data-id="element-240" data-mp="2cd9pdaqsdsxm" data-mpi={i}>
              <span className={`flex items-center gap-1.5 whitespace-nowrap text-[15px] md:gap-2 md:text-[20px] text-fg/70 transition-colors duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] group-hover:text-fg/90 [&_svg]:h-[15px] [&_svg]:w-[15px] md:[&_svg]:h-[18px] md:[&_svg]:w-[18px] ${logo.style}`} data-id="element-241" data-mp="2v40tnxvx2t55">
                <LogoMark mark={logo.mark} data-id="element-242" data-mp="3c780gmzsyfok" />
                <span data-id="element-243" data-mp="3h4hwwmllzrlw">{logo.name}</span>
              </span>
            </li>)}
        </motion.ul>
      </div>
    </section>;
}